<template>
  <div class="list-item">
    <div class="image-container">
      <div class="image" v-lazy:background-image="item.image" :key="item.image">
        <div v-if="item.socialNetwork === 1" class="ins-user-icon"></div>
        <div v-if="item.socialNetwork === 2" class="fb-page-user-icon"></div>
        <div v-if="item.socialNetwork === 3" class="fb-group-user-icon"></div>
        <div v-if="item.socialNetwork === 4" class="tw-user-icon"></div>
      </div>
      <div class="username">{{ item.username }}</div>
    </div>
    <div style="width: 105px; margin-left: 35px; padding-right: 10px">
      <el-popover
        placement="bottom"
        width="248"
        v-model="removeModal"
        trigger="click"
      >
        <div class="remove-container">
          <div class="message">
            All schedules on this social account will not auto post after your
            remove it. Confirm remove?
          </div>
          <div class="btn-group">
            <div class="btn" @click="removeModal = false">Cancel</div>
            <div class="btn" @click="removeClick(item)">Yes</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
export default {
  name: "AccountListItemComponent",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      removeModal: false,
    };
  },
  methods: {
    removeClick() {
      this.removeModal = false;
      this.$emit("removeClick", this.item);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.list-item {
  height: 60px;
  display: flex;
  align-items: center;
  .image-container {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    .image {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-position: center;
      background-size: cover;
      position: relative;
    }
    .username {
      margin-left: 15px;
      font-size: 15px;
    }
  }
  .remove-btn {
    text-align: right;
    font-size: 15px;
    cursor: pointer;
    &:active,
    &:hover {
      opacity: 0.8;
    }
  }
}

.remove-container {
  height: 130px;
  padding: 30px;
  .message {
    font-size: 14px;
    text-align: center;
    width: 100%;
  }
  .btn-group {
    display: flex;
    margin-top: 35px;
    justify-content: space-between;
    .btn {
      width: 88px;
      height: 28px;
      background-color: #e72955;
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:active,
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
